module.exports = __webpack_public_path__ + "static/media/health.09970b0e.gltf";